import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_NurseAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_NurseAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className="w-750">
                    <span className="eleHeader">Chief Complaint:</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Present Illness:</span>
                    <textarea id="txtPresentIllness" name="txtPresentIllness" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Past Medical History:</span>
                    <textarea id="txtPastMedicalHistory" name="txtPastMedicalHistory" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Past Surgical History:</span>
                    <textarea id="txtPastSurgicalHistory" name="txtPastSurgicalHistory" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Social History:</span>
                    <textarea id="txtSocialHistory" name="txtSocialHistory" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Medications:</span>
                    <textarea id="txtMedications" name="txtMedications" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Allergies:</span>
                    <textarea id="txtAllergies" name="txtAllergies" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Review of Systems:</span>
                    <textarea id="txtSystemsReview" name="txtSystemsReview" className="add-only"  ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Physical Examination</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <b>BP:</b> <input type="text" id="txtBP" name="txtBP" className="add-only" />
                        </td>
                        <td className="w-250">
                            <b>P:</b> <input type="text" id="Text1" name="txtP" className="add-only" />
                        </td>
                        <td className="w-250">
                            <b>T:</b> <input type="text" id="Text2" name="txtT" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <b>R:</b> <input type="text" id="Text3" name="txtR" className="add-only" />
                        </td>

                        <td className="w-250">
                            <b>Height (inches): </b><input type="text" id="txtHeight" name="txtHeight" className="add-only" />
                        </td>
                        <td className="w-250">
                            <b> Weight (lbs): </b><input type="text" id="txtWeight" name="txtWeight" className="add-only" />
                        </td>
                        <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750"><span className="eleHeader">Mental Status</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentalStatus_Alert" name="cbMentalStatus_Alert" className="add-only" value="Alert" /> Alert
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentalStatus_Oriented" name="cbMentalStatus_Oriented" className="add-only" value="Oriented" /> Oriented
                        </td>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentalStatus_Confused" name="cbMentalStatus_Confused" className="add-only" value="Confused" /> Confused
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" id="cbMentalStatus_Other" name="cbMentalStatus_Other" className="add-only" value="Other" /> Other:
                            <input type="text" id="txtMentalStatus_Other" name="txtMentalStatus_Other" className="add-only" />
                        </td>
                        <td className="w-250">&nbsp; </td>
                        <td className="w-250">&nbsp; </td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">General:</span>
                    <textarea id="txtGeneral" name="txtGeneral" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Skin:</span>
                    <textarea id="txtSkin" name="txtSkin" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">HEENT:</span>
                    <textarea id="txtHEENT" name="txtHEENT" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Chest & Lungs:</span>
                    <textarea id="txtChestLungs" name="txtChestLungs" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Heart:</span>
                    <textarea id="txtHeart" name="txtHeart" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Abdomen:</span>
                    <textarea id="txtAbdomen" name="txtAbdomen" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Neurologic:</span>
                    <textarea id="txtNeurologic" name="txtNeurologic" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Musculoskeletal:</span>
                    <textarea id="txtMusculoskeletal" name="txtMusculoskeletal" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Extremities:</span>
                    <textarea id="txtExtremities" name="txtExtremities" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Impression:</span>
                    <textarea id="txtImpression" name="txtImpression" className="add-only"  ></textarea>
                </p>
                <p className="w-750">
                    <span className="eleHeader">Plan of Care:</span>
                    <textarea id="txtCarePlan" name="txtCarePlan" className="add-only"  ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-300 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-300 small">Print Name</td>
                        <td className="w-300 small">Signature</td>
                        <td className="w-150 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}